<template>
  <div class="contactUs">
    <Header></Header>
    <slideshow></slideshow>


    <div class="content">
      <div class="content_left">
        <el-tabs :tab-position="tabPosition">
          <div class="rightData_box">
            <div class="rightData">
              <div>
                <div class="business">
                  <span class="titlebar">联系我们</span>
                  <div class="arrow-right">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">你现在所在的位置</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>联系我们</el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>
                </div>
                <h2 class="caption">{{ arr.gsmc }}</h2>
                <div class="basic_message">
                  <div>联系人:{{ arr.person }}</div>
                  <div>联系电话:{{ arr.phone }}</div>
                  <div>联系邮箱:{{ arr.mail }}</div>
                  <div>联系地址:{{ arr.address }}</div>
                </div>
                <!-- <img src="../../assets/img/025c37e225c6026df83dde4d091eb71.png" class="map" /> -->
                <img :src="url+this.arr.img" class="map" />
              </div>
            </div>
          </div>
        </el-tabs>
      </div>
      <div v-show="cur == 2" class="aaa">acaasascascascascsca</div>
      <div></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../../components/haed/haed";
import Footer from "../../components/haed/footer";
import slideshow from "../../components/haed/slideshow";
import axios from "axios";
export default {
  name: "contactUs",
  components: {
    Header,
    Footer,
    slideshow,
  },
  data() {
    return {
      cur: 1,
      arr: [],
      tabPosition: "left",
      url:this.$axios.defaults.baseURL,
    };
  },
  created() {
    this.contactus();
  },
  methods: {
    contactus: function () {
      this.$axios({
        // method: "post",
        // url: "/index.php/about",
        // header: {
        //   "Content-Type": "application/x-www-form-urlencoded", //post请求设置
        // },
        method: "get",
        url: "/changhang/contact/list",
      })
        .then((res) => {
          console.log("11111118989",res);
          this.arr = res.data.rows[0];
          //  console.log(res);
        })
        .catch((res) => {
          // console.log("1111111" + res);
        });
    },
  },
};
</script>

<style scoped>
.rightData_box {
  width: 100%;
  margin-bottom: 2%;
}

.rightData {
  /* width: 90%;
margin-left: 6%; */
}

.el-tabs--left,
.el-tabs--right {
  margin-left: 0;
}

.content {
  /* width: 100%; */
  width: 1000px;
  display: flex;
  margin-top: 28px;
  margin: auto;

}

.content_left {
  width: 100%;
}

.content_rigth {
  width: 77%;
  margin-left: -10%;
}

.basic_message {
  margin-top: 10px;
  margin-bottom: 25px;
}

.basic_message div {
  color: #7a7a78;
  line-height: 2;
  font-size: 16px;
}

.caption {
  color: #a6a6a4;
  margin-top: 12px;
  font-size: 18px;
}

.Figure_contact img {
  width: 100%;
  height: 600px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.business {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #dcdcdc;
  margin: 15px 0;
  line-height: 2;
}

.titlebar {
  font-weight: bold;
  font-size: 32px;
  color: #31518c;
  /* line-height: 2; */
}

.arrow-right {
  margin-top: 26px;
}

.crumbs {
  display: flex;
}

.crumbs span {
  color: #969696;
}

/* .slash {
  text-align: center;
  border: 1px solid #eee;
  margin: 0 0 -1px -1px;
  border-right: none;
  line-height: 1.9vw;
  height: 1.9vw;
} */
.el-row {
  padding-left: 5%;
}

.el-submenu .el-menu-item {
  min-width: 1px;
}

.el-breadcrumb {
  /* line-height: 1.5; */
  /* font-size: 0.9vw; */
  font-size: 16px;
}

.map {
  /* width: 73vw; */
}

@media screen and (min-width: 320px) and (max-width: 750px) {
  .titlebar {
    display: none;
  }

  .business {
    display: none;
  }

  .content {
    width: 100%;
  }

  .map {
    width: 100%;

  }

  .basic_message div {
    font-size: 14px;
  }
}
</style>
<style>
/* .contactUs .el-submenu__title {
  background-color: #0c47a1;
  color: #fff;
  text-align: center;
}
  .el-tabs--left,
.el-tabs--right {
  margin-left: 20px;
  margin-top: 20px;
}
.el-tabs--left .el-tabs__item.is-left {
  font-size: 24px;
  height: 50px;
} */</style>


// WEBPACK FOOTER //
// src/pages/contactUs/contactUs.vue